import { render, staticRenderFns } from "./EmptyDash.vue?vue&type=template&id=6615383e&scoped=true&"
import script from "./EmptyDash.vue?vue&type=script&lang=js&"
export * from "./EmptyDash.vue?vue&type=script&lang=js&"
import style0 from "./EmptyDash.vue?vue&type=style&index=0&id=6615383e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6615383e",
  null
  
)

export default component.exports